import React, {useEffect, useState, memo, Fragment, useCallback} from 'react';
import {    
    Button,
    Chip,
    Dialog,
    DialogActions,
    DialogContent, 
    Divider,
    FormGroup,
    FormControlLabel,  
    Grid,
    IconButton,
    InputAdornment,
    LinearProgress,
    Paper,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
    TextField,
    Tooltip,
    Typography
} from '@material-ui/core';
import { 
    AccountCircle as AccountCircleIcon,
    AddCircleOutline as AddCircleOutlineIcon,
    AddLocation as AddLocationIcon,
    ArrowDownward as ArrowDownwardIcon,
    ArrowUpward as ArrowUpwardIcon,
    AssignmentLate as AssignmentLateIcon,
    AttachMoney as AttachMoneyIcon,
    Ballot as BallotIcon,
    Close as CloseIcon,
    Delete as DeleteIcon,
    Http as HttpIcon,
    Nature as NatureIcon,
    Person as PersonIcon,
    Speed as SpeedIcon,
    VpnLock as VpnLockIcon,
    VpnKey as VpnKeyIcon,
    Edit as EditIcon,
    //ListAlt as ListAltIcon,
    Save as SaveIcon,
    //SignalWifi4Bar as SignalWifi4BarIcon,
    Visibility as VisibilityIcon,
    VisibilityOff as VisibilityOffIcon
} from '@material-ui/icons';
import { red } from '@material-ui/core/colors';
import { makeStyles, withStyles  } from '@material-ui/core/styles';
import { SnackbarProvider, useSnackbar } from 'notistack';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { Alert } from '@material-ui/lab';
import FacebookCircularProgress from '../Elementos/FacebookCircularProgress';
import styled from 'styled-components';
import Swal from 'sweetalert2';
import { Autocomplete } from '@material-ui/lab';
import { 
    ClusterOutlined as ClusterOutlinedIcon,
    CopyOutlined as ContentCopyIcon, 
} from '@ant-design/icons';
import { useAuth } from "../Auth";
import { v4 as uuidv4 } from 'uuid'; 
import { 
    Modal as ModalAntd,
    Popconfirm,
    Switch as SwitchAntd, 
    Tooltip as TooltipAntd, 
} from 'antd';

const TrYounetStyled = styled.tr`
    display:flex;
    z-index:2;
    background-color:${props => props.selected ? 'LightBlue' : '#fff'};
    &:hover{
        background-color:Gainsboro
    }
`;

const TdYounetStyled = styled.td`
    color:${props => props.color ? props.color : 'black'};
    font-size:${props => props.fontSize ?  props.fontSize : '10px'};
    font-weight:${props => props.bolder ? 'bold' : 'none'};
    min-width:${props => props.minWidth || 100};
    width:${props => props.width || 100};
    padding-top:${props => props.element ? '0px' : '5px'}; 
    text-align:${props => props.align ? props.align : 'left'};
    background:transparent;
    border-bottom: 1px solid #E5E8E8;
    display:block;
    height:40px;
    max-height:40px;
    padding:8px;   
    position:relative;
    left:0px;      
    text-overflow: ellipsis;    
    white-space: nowrap; 
    overflow: hidden;
    line-height:25px;
`;

const TheadYounetStyled = styled.th`
    text-align:${props => props.align ? props.align : 'left'};
    min-width:${props => props.width || 60};
    width:${props => props.width || 100};
    background-color:#0E3B5F;
    color: #fff;
    display:block;
    font-weight:bold, 
    height:33px;
    max-height:33px;
    padding-left:10px;
    padding-top:6px;
    position: relative;
    left:0px;   
`;

const TheadYounet = memo(({widthDefault, createSortHandler, order, orderBy, headCell, classes, align})=>( 
    <TheadYounetStyled width={widthDefault} align={align}>
        <TableSortLabel
            active={orderBy === headCell.id}
            direction={orderBy === headCell.id ? order : 'asc'}
            onClick={createSortHandler(headCell.id)} 
            style={{color:'#fff', textAlign:align}}
        >
            {headCell.label}
            {orderBy === headCell.id ? (
            <span className={classes.visuallyHidden}>
                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
            </span>
            ) : null}
        </TableSortLabel>
    </TheadYounetStyled>
));

const columns = [
    { id: 'Action', label: 'Action', minWidth: 217.5,numeric: false, disablePadding: false },
    { id: 'Zona', label: 'Zona', minWidth: 197,numeric: false, disablePadding: false },
    { id: 'IP', label: 'IP', minWidth: 190,numeric: false, disablePadding: false },
    { id: 'Puerto', label: 'Puerto', minWidth: 120, numeric: false, disablePadding: false },
    { id: 'Marca', label: 'Marca', minWidth: 190, numeric: false, disablePadding: false },
    { id: 'Modelo', label: 'Modelo', minWidth: 200, numeric: false, disablePadding: false}, 
    { id: 'Usuario', label: 'Usuario', minWidth: 200, numeric: false, disablePadding: false}, 
    { id: 'Password', label: 'Password', minWidth: 200, numeric: true, disablePadding: false}, 
];

const styles2 = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: red[900],
    },
});

const DialogTitle = withStyles(styles2)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
});

const styles = makeStyles((theme)=>({
    paper:{
        padding:20
    },
    button:{
        color:'#fff'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
})); 

function capitalize(word) { return word[0].toUpperCase() + word.slice(1) };

const RowRB = ({rowInfo, handleDelete, handleUpdate, Marcas, ModelosList, handleProcess, Empresas})=>{
    const { enqueueSnackbar } = useSnackbar();
    const [ openDialog, setOpenDialog ] = useState(false);
    const [ openDialogInformacion, setOpenDialogInformacion ] = useState(false);
    const [ openPlanes, setOpenPlanes ] = useState(false);
    const [ informacionRB, setInformacionRB ] = useState([]);
    const [ continuoInformacion, setContinuoInformacion ] = useState(false);
    const [ openDialogInformacion2, setOpenDialogInformacion2 ] = useState(false);
    const [ openDialogEditInformacion, setOpenDialogEditInformacion ] = useState(false);
    const [ continuoInformacion2, setContinuoInformacion2 ] = useState(false);
    const [ informacion, setInformacion ] = useState({});
    const [ showPass, setShowPass ] = useState(false);
    const [ showLogs, setShowLogs ] = useState(false);
    const [ isProcessing, setProcessing ] = useState(false);
    const [ isInfoCharging, setInfoCharging ] = useState(false);
    const [ isLogs, setLogs ] = useState([]);
    const [ Datos, setDatos ] = useState({ 
        AddClientMikrotik:false, 
        IP:'192.168',
        isFibraOptica:false ,
        Marca:'', 
        Modelo:'', 
        Nombre:'',
        Tipo:'',   
        PagosConexion:false,
        Password:'', 
        Planes:[],
        planLocal:false,
        ppoeList:false, 
        queueTree:false,
        simpleQueue:false,
        sysintercom:false,
        Usuario:'admin', 
        isIptv:false
    });
    const [ arrPlanes, setArrPlanes ] = useState([{Plan:'',Subida:'', Bajada:'', Valor:'', id:Math.floor(Math.random() * 10000000)}]);
    const [ arrSubnet, setArrSubnet ] = useState([{Red:'',Mascara:0, id:Math.floor(Math.random() * 10000000)}]);
    const [ arrSubnetIptv, setArrSubnetIptv ] = useState([{Red:'',Mascara:0, id:Math.floor(Math.random() * 10000000)}]);
    const [ Modelos, setModelos ] = useState([]);
    const [ isDisableModelo, setDisableModelo ] = useState(false);
    const [ openCopy, setOpenCopy ] = useState(false);
    const [ openConfirm, setOpenConfirm ] = useState(false);
    const { authTokens } = useAuth(); 
    const [ getNewZone, setNewZone ] = useState('');
    const [ openChangeZone, setOpenChangeZone ] = useState(false);
    

    useEffect(()=>{
        if(rowInfo.Planes.length > 0 ) setArrPlanes(rowInfo.Planes);
    },[]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(()=>{
        if(continuoInformacion){
            setContinuoInformacion(false);
            setOpenDialogInformacion(true);
        }
    },[continuoInformacion]);

    useEffect(()=>{
        if(continuoInformacion2){
            setContinuoInformacion2(false);
            setOpenDialogInformacion2(true);
        }
    },[continuoInformacion2]);

    const handleSubDelete = ()=>{
        fetch('api/zonas',{
            method:'DELETE',
            body: JSON.stringify({_id:rowInfo._id}),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                handleDelete(rowInfo)            
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
            }
        });
    };

    const handleAlert = ()=>{ setOpenDialog(true); };

    const handleAlertClose = ()=>{ setOpenDialog(false); };

    const handleAlertCloseInformacion = ()=>{ setOpenDialogInformacion(false); };

    const handleAlertCloseInformacion2 = ()=>{ setOpenDialogInformacion2(false); };

    const handleInformacion = ()=>{
        setInfoCharging(true);
        fetch('api/mikrotik/interfaces',{
            method:'POST',
            body: JSON.stringify(rowInfo),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
 //  console.log(result)
            if(result.status){
                Swal.fire({
                    title:result.status,
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                })
                setInfoCharging(false);
            }else{
                const arr = [];
                result.forEach((value, index)=>{
                    const objeto = {};
                    value.forEach((value2, index2)=>{ 
                        const splitKey = value2.field.split('-');
                        switch(splitKey.length){
                            case 2: 
                                let key2 = `${splitKey[0].toString()}${capitalize(splitKey[1])}`
                                objeto[key2] = value2.value; 
                                break;
                            case 3: 
                                let key3 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}`
                                objeto[key3] = value2.value;
                                break;
                            case 4: 
                                let key4 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}${capitalize(splitKey[3])}`
                                objeto[key4] = value2.value;
                                break;
                            default:
                                objeto[value2.field] = value2.value;
                                break;
                        }
                    })
                    objeto.id = `Interfaces_${index}`
                    arr.push(objeto)
                });
                setInformacionRB(arr);
                setContinuoInformacion(true);
                setInfoCharging(false);
            }
        }); 
    };

    const handleInformacionStatus = ()=>{
        setInfoCharging(true);
        fetch('api/mikrotik/informacion',{
            method:'POST',
            body: JSON.stringify(rowInfo),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
 //  console.log(result)
            if(result.status){
                Swal.fire({
                    title:result.status,
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                })
                setInfoCharging(false);
            }else{
                const objeto = {};
                result.forEach(value=>{
                    let splitKey = value.field.split('-');
                    switch(splitKey.length){
                        case 2: 
                            let key2 = `${splitKey[0].toString()}${capitalize(splitKey[1])}`
                            objeto[key2] = value.value; 
                            break;
                        case 3: 
                            let key3 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}`
                            objeto[key3] = value.value; 
                            break;
                        case 4: 
                            let key4 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}${capitalize(splitKey[3])}`
                            objeto[key4] = value.value; 
                            break;
                        default:
                            objeto[value.field] = value.value; 
                            break;
                    }
                })
                setInformacion(objeto);
                setContinuoInformacion2(true);
                setInfoCharging(false);
            }
        }); 
    };

    const handlePass = ()=>{ setShowPass(!showPass); };

    const handleLogs = ()=>{
        setInfoCharging(true);
        fetch('api/mikrotik/log',{
            method:'POST',
            body: JSON.stringify(rowInfo),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
 //  console.log(result)
            if(result.status){
                Swal.fire({
                    title:result.status,
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                })
                setInfoCharging(false);
            }else{
                const arr = [];
                result.forEach(value=>{
                    const objeto = {};
                    value.forEach(value2=>{ 
                        const splitKey = value2.field.split('.');
                        switch(splitKey.length){
                            case 2: 
                                let key2 = '_id'
                                objeto[key2] = value2.value; 
                                break;
                            default:
                                objeto[value2.field] = value2.value; 
                                break;
                        }
                    });
                    arr.push(objeto)
                });
                setLogs(arr);
                setShowLogs(true);
                setInfoCharging(false);
            }
            
        }); 
    };

    const handleAlertLogClose = ()=>{ setShowLogs(false); };

    const handleAlertCloseEditInformacion = ()=>{
        setOpenDialogEditInformacion(false);
        setDatos({
            AddClientMikrotik:false, 
            IP:'192.168',
            isFibraOptica:false ,
            Marca:'', 
            Modelo:'', 
            Nombre:'',
            Tipo:'',   
            PagosConexion:false,
            Password:'', 
            Planes:[],
            planLocal:false,
            ppoeList:false, 
            queueTree:false,
            simpleQueue:false,
            sysintercom:false,
            Usuario:'admin', 
        });
        setArrSubnet([{Red:'', Mascara:0, id:Math.floor(Math.random() * 10000000)}]);
    };

    const handleDatos = ({target})=>{ 
        if(target.name === 'Canton' || target.name === 'Provincia' || target.name === 'Parroquia' || target.name === 'Ciudad'){
            setDatos({...Datos, [target.name]:target.value.toUpperCase()}) 
        }else{
            setDatos({...Datos, [target.name]:target.value}) 
        }
    }

    const handleSwitch = (e)=>{
        switch(e.target.name){
            case 'simpleQueue':
                setDatos({...Datos, simpleQueue:e.target.checked, queueTree:false, ppoeList:false, sysintercom:false});
                break;
            case 'queueTree':
                setDatos({...Datos, queueTree:e.target.checked, simpleQueue:false, ppoeList:false, sysintercom:false});
                break;
            case 'ppoeList':
                setDatos({...Datos, ppoeList:e.target.checked, simpleQueue:false, queueTree:false, sysintercom:false});
                break;
            case 'sysintercom':
                setDatos({...Datos, sysintercom:e.target.checked, simpleQueue:false, queueTree:false, ppoeList:false});
                break;
            default:
                setDatos({...Datos, sysintercom:false, simpleQueue:false, queueTree:false, ppoeList:false});
                break;
        };
    };

    const handleSwitchPago = (checked)=>{ setDatos({...Datos, PagosConexion:checked}) };

    const handleSwitchPlanes = (checked)=>{ setDatos({...Datos, planLocal:checked}) };

    const handleSwitchAdd = (checked)=>{ setDatos({...Datos, AddClientMikrotik:checked}) };

    const handleSwitchFibra = (checked)=>{ setDatos({...Datos, isFibraOptica:checked}) };
    
    const handleClickEdit =  ()=>{
        setDatos(rowInfo);
        rowInfo.Planes.length > 0 && setArrPlanes( rowInfo.Planes );
        setArrSubnet(rowInfo.Subnet);
        rowInfo.isIptv && setArrSubnetIptv(rowInfo.SubnetIptv);
        setOpenDialogEditInformacion(true);
    };

    const handlePlanes = useCallback((idPlan, valPlan)=>{
        const arrP = [...arrPlanes];
        const arr = arrP.map(value=>{
            const objeto = {...value}
            if(value.id === idPlan){
                return valPlan;
            }else{
                return objeto;
            }
        });
        setArrPlanes(arr);
    },[arrPlanes]);

    const handleCrearPlanes = useCallback(()=>{
        const arrP = [...arrPlanes];
        const objeto = {Plan:'',Subida:'', Bajada:'', Valor:'', id:Math.floor(Math.random() * 10000000)};
        arrP.push(objeto);
        setArrPlanes(arrP);
    },[arrPlanes]);
    
    const handleBorrarPlanes = useCallback((id)=>{
        const arrP = [...arrPlanes];
        const filPlanes = arrP.filter(value=> value.id !== id);
        setArrPlanes(filPlanes);
    },[arrPlanes]);

    const PlanesEl = arrPlanes.map((value, index)=>(
        <ElementPlan 
            index={index} 
            key={value.id} 
            data={value} 
            id={value.id}  
            total={arrPlanes.length} 
            handlePlanes={handlePlanes}
            handleCrearPlanes={handleCrearPlanes}
            handleBorrarPlanes={handleBorrarPlanes}
            arrPlanes={arrPlanes}
            valor={value}
        />
    ));

    const handleSubnet = useCallback((idSubnet, valPlan)=>{
        const arrP = [...arrSubnet];
        const arr = arrP.map(value=>{
            const objeto = {...value}
            if(value.id === idSubnet){
                return valPlan;
            }else{
                return objeto;
            }
        });
        setArrSubnet(arr);
    },[arrSubnet]);

    const handleCrearSubnet = useCallback(()=>{
        setArrSubnet([...arrSubnet, {Red:'',Mascara:0, id:Math.floor(Math.random() * 10000000)}]);
    },[arrSubnet]);
    
    const handleBorrarSubnet = useCallback((id)=>{
        const arrP = [...arrSubnet];
        const filSubnet = arrP.filter(value=> value.id !== id);
        setArrSubnet(filSubnet);
    },[arrSubnet]);

    const SubnetEl = arrSubnet.map((value, index)=>(
        <ElementSubnet index={index} key={value.id} data={value} id={value.id}  
          total={arrSubnet.length} 
          handleSubnet={handleSubnet}
          handleCrearSubnet={handleCrearSubnet}
          handleBorrarSubnet={handleBorrarSubnet}
          arrSubnet={arrSubnet}
          valor={value}
        />
    ));

    const handleSubnetIptv = useCallback((idSubnet, valPlan)=>{
        const arrP = [...arrSubnetIptv];
        const arr = arrP.map(value=>{
            const objeto = {...value}
            if(value.id === idSubnet){
                return valPlan;
            }else{
                return objeto;
            }
        });
        setArrSubnetIptv(arr);
    },[ arrSubnetIptv ]);

    const handleCrearSubnetIptv = useCallback(()=>{
        setArrSubnetIptv([...arrSubnetIptv, {Red:'',Mascara:0, id:Math.floor(Math.random() * 10000000)}]);
    },[ arrSubnetIptv ]);
    
    const handleBorrarSubnetIptv = useCallback((id)=>{
        const arrP = [...arrSubnetIptv];
        const filSubnet = arrP.filter(value=> value.id !== id);
        setArrSubnetIptv(filSubnet);
    },[ arrSubnetIptv ]);

    const SubnetElIptv = arrSubnetIptv.map((value, index)=>(
        <ElementSubnetIptv index={index} key={value.id} data={value} id={value.id}  
          total={arrSubnetIptv.length} 
          handleSubnetIptv={handleSubnetIptv}
          handleCrearSubnetIptv={handleCrearSubnetIptv}
          handleBorrarSubnetIptv={handleBorrarSubnetIptv}
          arrSubnetIptv={arrSubnetIptv}
          valor={value}
        />
    ));

    const handleEditEquipo =()=>{
        setProcessing(true);
        const objeto = {...Datos};
        objeto.arrPlanes = [...arrPlanes];
        objeto.arrSubnet = [...arrSubnet];
        objeto.arrSubnetIptv = [...arrSubnetIptv];
        fetch('api/zonas',{
            method:'PUT',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result._id){
                handleUpdate(result);
                enqueueSnackbar('Equipo Editado', {variant:'success'}); 
                setTimeout(()=>{
                    setProcessing(false);
                },1000)      
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
            }
        });
    };

    const handleSelectMarca = (value)=>{
        setDatos({...Datos, Marca:value });
        const arrF2 = ModelosList.filter(value2=>value2.Marca === Datos.Marca);
        setDisableModelo(false);
        setModelos(arrF2);
    };

    const handleClearMarca = ()=>{
        setDatos({...Datos, Marca:'', Modelo:''});
        setDisableModelo(true);
        setModelos([]);
    };

    const handleSelectModelo = (value)=>{ setDatos({...Datos, Modelo:value.toString().trim()});};

    const handleClearModelo = ()=>{setDatos({...Datos, Modelo:''});};

    const handleOpenPlanes = ()=>{ 
        setDatos(rowInfo);
        setArrSubnet(rowInfo.Subnet);
        setArrSubnetIptv(rowInfo.Subnet);
        rowInfo.Planes.length > 0 && setArrPlanes( rowInfo.Planes );
        setOpenPlanes(true);
    };

    const handleClosePlanes = ()=>{ 
        setOpenPlanes(false);
        setDatos({
            AddClientMikrotik:false, 
            IP:'192.168',
            isFibraOptica:false ,
            Marca:'', 
            Modelo:'', 
            Nombre:'',
            Tipo:'',   
            PagosConexion:false,
            Password:'', 
            Planes:[],
            planLocal:false,
            ppoeList:false, 
            queueTree:false,
            simpleQueue:false,
            sysintercom:false,
            Usuario:'admin', 
        });
        setArrPlanes([{Plan:'',Subida:'', Bajada:'', Valor:'', id:Math.floor(Math.random() * 10000000)}]);
        setArrSubnet([{Red:'', Mascara:0, id:Math.floor(Math.random() * 10000000)}]);
        setArrSubnetIptv([{Red:'', Mascara:0, id:Math.floor(Math.random() * 10000000)}]);  
    };

    const handleOpenCopy = ()=>{ 
        setDatos(rowInfo);
        setArrSubnet(rowInfo.Subnet);
        setArrSubnetIptv(rowInfo.Subnet);
        setArrPlanes(rowInfo.Planes);
        setOpenCopy(true);
    };

    const handleCloseCopy = ()=>{ 
        setOpenCopy(false);
        setDatos({
            AddClientMikrotik:false, 
            IP:'192.168',
            isFibraOptica:false ,
            Marca:'', 
            Modelo:'', 
            Nombre:'',
            Tipo:'',   
            PagosConexion:false,
            Password:'', 
            Planes:[],
            planLocal:false,
            ppoeList:false, 
            queueTree:false,
            simpleQueue:false,
            sysintercom:false,
            Usuario:'admin', 
        });
        setArrPlanes([{Plan:'',Subida:'', Bajada:'', Valor:'', id:Math.floor(Math.random() * 10000000)}]);
        setArrSubnet([{Red:'', Mascara:0, id:Math.floor(Math.random() * 10000000)}]);    
        setArrSubnetIptv([{Red:'', Mascara:0, id:Math.floor(Math.random() * 10000000)}]);  
    };

    const handleSaveCopy = ()=>{
        const objeto = {...Datos};
        delete objeto._id;
        objeto.UsuarioCreate = authTokens.Usuario;
        objeto.Planes = [...arrPlanes];
        objeto.Subnet = [...arrSubnet];
        objeto.SubnetIptv = [...arrSubnetIptv];
        objeto.uuid = uuidv4();
        fetch('api/zonas',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar('Zona Guardada', {variant:'success'});
                setProcessing(false);
                handleProcess(result.message);
                setDatos({ 
                    AddClientMikrotik:false, 
                    IP:'192.168',
                    isFibraOptica:false ,
                    Marca:'', 
                    Modelo:'', 
                    Nombre:'',
                    Tipo:'',   
                    PagosConexion:false,
                    Password:'', 
                    Planes:[],
                    planLocal:false,
                    ppoeList:false, 
                    queueTree:false,
                    simpleQueue:false,
                    sysintercom:false,
                    Usuario:'admin', 
                });
                setArrSubnet([{Red:'', Mascara:0, id:'Subnet_1'}]);
                setOpenConfirm(false);
                setOpenCopy(false);
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setProcessing(false);
            }
        });   
    };

    const handleChangeNameZone = ()=>{
        if(getNewZone === ''){
            alert('CAMPO DE ZONA NUEVA VACIO')
        }else{
            setProcessing(true);
            const objeto = {};
            objeto._id = rowInfo._id;
            objeto.newZone = getNewZone;
            objeto.Zona = rowInfo.Zona;
            fetch('api/zonas/ChangeName',{
                method:'POST',
                body: JSON.stringify(objeto),
                headers:{
                    'Content-Type': 'application/json'
                }
            }) 
            .then(response=> response.json())
            .then(result =>{
                if(result._id){
                    handleUpdate(result);
                    enqueueSnackbar('ZONA EDITADA', {variant:'success'}); 
                    setTimeout(()=>{
                        setProcessing(false);
                    },1000)      
                }else{
                    setProcessing(false);
                    enqueueSnackbar(result.status, {variant:'error'});
                }
            });  
        }
        
    }

    const handleCloseConfirm = ()=>{ setOpenConfirm(false);}

    return(
        <div key={rowInfo._id}>
            <Dialog
                open={openDialog}
                onClose={handleAlertClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Desea Eliminar este Equipo"} </DialogTitle>
                <DialogActions style={{display:'flex', justifyContent:'center'}}>
                <Button onClick={handleSubDelete} color="primary" variant='contained' style={{color:'#fff'}}>
                    Si
                </Button>
                <Button onClick={handleAlertClose} color="default" variant='contained' style={{color:'#fff', background:'#dc004e'}}>
                    No
                </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openDialogInformacion}
                onClose={handleAlertCloseInformacion}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="customized-dialog-title" onClose={handleAlertCloseInformacion}>
                    Informacion de R.B.
                </DialogTitle>
                <DialogContent>
                    <Paper style={{width:'100%'}}>
                        <TableContainer style={{maxHeight: 440}}>
                            <Table stickyHeader aria-label="simple table" >
                                <TableHead>
                                <TableRow>
                                    <TableCell>INTERFACE</TableCell>
                                    <TableCell>Zona</TableCell>
                                    <TableCell>MAC</TableCell>
                                    <TableCell>STATUS</TableCell>
                                </TableRow>
                                </TableHead>
                                <TableBody>
                                {informacionRB.map((row) => (
                                    <TableRow key={row.id}>
                                        <TableCell > {row.defaultName}</TableCell>
                                        <TableCell >{row.name}</TableCell>
                                        <TableCell >{row.macAddress}</TableCell>
                                        <TableCell >{row.disabled === 'false' ? 'ON' : 'OFF'}</TableCell>
                                    </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </DialogContent> 
                
            </Dialog>   
            <Dialog
                open={openDialogInformacion2}
                onClose={handleAlertCloseInformacion2}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="customized-dialog-title" onClose={handleAlertCloseInformacion2}>
                    Caracteristicas
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={1}>
                        <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                            <TextField id="standard-basic" label="FIRMWARE" value={informacion.version} fullWidth/>
                        </Grid>
                        <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                            <TextField id="standard-basic" label="MODELO" value={informacion.boardName} fullWidth/>
                        </Grid>
                        <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                            <TextField id="standard-basic" label="CPU" value={`${informacion.cpu} - ${informacion.cpuCount}`} fullWidth/>
                        </Grid>
                        <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                            <TextField id="standard-basic" label="STATUS CPU %" value={informacion.cpuLoad} fullWidth/>
                        </Grid>
                        <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                            <TextField id="standard-basic" label="MEMORIA" value={informacion.totalMemory / 1048576} fullWidth/>
                        </Grid>
                        <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                            <TextField id="standard-basic" label="MEMORIA LIBRE" value={(informacion.freeMemory / 1048576).toFixed(2)} fullWidth/>
                        </Grid>
                    </Grid>
                </DialogContent> 
            </Dialog>  
            <Dialog
                open={openDialogEditInformacion}
                onClose={handleAlertCloseEditInformacion}
                fullScreen
            >
                <DialogTitle id="customized-dialog-title" onClose={handleAlertCloseEditInformacion}>
                    Informacion de Zona
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={3}>
                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                        {isProcessing ? <LinearProgress color='secondary' /> : <div style={{height:4}}></div>}
                        </Grid>     
                        <Grid item lg={2} md={4} sm={6} xs={12}>
                            <Autocomplete
                                id="Marca"
                                options={Marcas.map(value=>value.Marca)}
                                value={Datos.Marca || ''}                              
                                renderInput={(params) => <TextField {...params} label="Marca" variant="outlined" size='small' fullWidth />}
                                onChange={(e,value, reason)=>{
                                    if(reason ===  'clear'){
                                        handleClearMarca()
                                    }else{
                                        handleSelectMarca(value);
                                    }
                                }}  
                            />
                        </Grid>                 
                        <Grid item lg={2} md={4} sm={6} xs={12}>
                            <Autocomplete
                                id="Modelo"
                                options={ModelosList.map(value=>value.Modelo)}
                                disabled={isDisableModelo}
                                value={Datos.Modelo || ''}                              
                                renderInput={(params) => <TextField {...params} label="Modelo" variant="outlined" size='small' fullWidth />}
                                onChange={(e,value, reason)=>{
                                    if(reason ===  'clear'){
                                        handleClearModelo()
                                    }else{
                                        handleSelectModelo(value);
                                    }
                                }}  
                            />
                        </Grid>   
                        <Grid item lg={2} md={4} sm={6} xs={12}>
                            <TextField
                                value={Datos.Zona || ''}
                                name='Zona'
                                label='Zona'
                                fullWidth
                                size='small'
                                variant='outlined'  
                                InputProps={{
                                    startAdornment: (
                                    <InputAdornment position="start">
                                        <AddLocationIcon color='primary'/>
                                    </InputAdornment>
                                    ),
                                }}                             
                            />
                        </Grid>
                        <Grid item lg={2} md={4} sm={6} xs={12}>
                            <TextField
                                value={Datos.IP || ''}
                                name='IP'
                                onChange={handleDatos}
                                label='IP'
                                fullWidth
                                size='small'
                                variant='outlined'  
                                InputProps={{
                                    startAdornment: (
                                    <InputAdornment position="start">
                                        <HttpIcon color='primary'/>
                                    </InputAdornment>
                                    ),
                                }}                               
                            />
                        </Grid> 
                        <Grid item lg={2} md={4} sm={6} xs={12}>
                            <TextField
                                value={Datos.IPSECONDARY || ''}
                                name='IPSECONDARY'
                                onChange={handleDatos}
                                label='IP SECUNDARIA'
                                fullWidth
                                size='small'
                                variant='outlined'  
                                InputProps={{
                                    startAdornment: (
                                    <InputAdornment position="start">
                                        <HttpIcon color='primary'/>
                                    </InputAdornment>
                                    ),
                                }}                               
                            />
                        </Grid> 
                        <Grid item lg={1} md={2} sm={3} xs={6}>
                            <TextField
                                value={Datos.Puerto || ''}
                                name='Puerto'
                                onChange={handleDatos}
                                label='Puerto API'
                                fullWidth
                                size='small'
                                variant='outlined' 
                                type='Number'                             
                            />
                        </Grid>
                        <Grid item lg={1} md={2} sm={3} xs={6} style={{display:'grid', placeContent:'center'}}>
                            <TooltipAntd title="IP PRIMARIA O SECUNDARIA" color='purple' >
                                <SwitchAntd 
                                    checked={Datos.isSecondary}
                                    checkedChildren="SECUNDARIA" 
                                    onChange={(checked)=>{ setDatos({...Datos, isSecondary:checked })}}
                                    unCheckedChildren="PRIMARIA" 
                                    
                                />
                            </TooltipAntd>              
                        </Grid>
                        <Grid item lg={2} md={3} sm={6} xs={12}>
                            <TextField
                                value={Datos.Nodo || ''}
                                name='Nodo'
                                onChange={handleDatos}
                                label='Nodo'
                                fullWidth
                                size='small'
                                variant='outlined'                              
                            />
                        </Grid>
                        <Grid item lg={2} md={3} sm={6} xs={12}>
                            <TextField
                                value={Datos.Usuario || ''}
                                name='Usuario'
                                onChange={handleDatos}
                                label='Usuario'
                                fullWidth
                                size='small'
                                variant='outlined'                              
                            />
                        </Grid>        
                        <Grid item lg={2} md={3} sm={6} xs={12}>
                            <TextField
                                value={Datos.Password || ''}
                                name='Password'
                                onChange={handleDatos}
                                label='Password'
                                fullWidth
                                size='small'
                                variant='outlined'                              
                            />
                        </Grid>
                        <Grid item lg={2} md={3} sm={6} xs={12}>
                            <Autocomplete
                                id="Empresa"
                                options={Empresas}
                                value={Datos.Empresa || ''}                              
                                renderInput={(params) => <TextField {...params} label="Empresa" variant="outlined" size='small' fullWidth />}
                                onChange={(e,value, reason)=>{
                                    if(reason ===  'clear'){
                                        setDatos({...Datos, Empresa:'' });
                                    }else{
                                        setDatos({...Datos, Empresa:value });
                                    }
                                }}  
                            />
                        </Grid>  
                        <Grid item lg={2} md={3} sm={6} xs={12}>
                            <TextField
                                value={Datos.Provincia || ''}
                                name='Provincia'
                                onChange={handleDatos}
                                label='Provincia'
                                fullWidth
                                size='small'
                                variant='outlined'                              
                            />
                        </Grid>
                        <Grid item lg={2} md={3} sm={4} xs={12}>
                            <TextField
                                value={Datos.Canton || ''}
                                name='Canton'
                                onChange={handleDatos}
                                label='Canton'
                                fullWidth
                                size='small'
                                variant='outlined'                              
                            />
                        </Grid>
                        <Grid item lg={2} md={3} sm={4} xs={12}>
                            <TextField
                                value={Datos.Parroquia || ''}
                                name='Parroquia'
                                onChange={handleDatos}
                                label='Parroquia'
                                fullWidth
                                size='small'
                                variant='outlined'                              
                            />
                        </Grid>
                        <Grid item lg={2} md={3} sm={4} xs={12}>
                            <TextField
                                value={Datos.Ciudad || ''}
                                name='Ciudad'
                                onChange={handleDatos}
                                label='Ciudad'
                                fullWidth
                                size='small'
                                variant='outlined'                              
                            />
                        </Grid>
                        <Grid item lg={1} md={3} sm={3} xs={3} style={{display:'grid', placeContent:'center'}}>
                            <TooltipAntd title="TIPO DE SERVICIO" color='purple' >
                                <SwitchAntd 
                                    checked={Datos.isFibraOptica}
                                    checkedChildren="FIBRA" 
                                    onChange={handleSwitchFibra}
                                    unCheckedChildren="RADIO" 
                                    
                                />
                            </TooltipAntd>              
                        </Grid>
                        <Grid item lg={3} md={6} sm={5} xs={9}>
                            <Grid container alignItems="center" spacing={1} style={{width:'100%'}} justifyContent='center'>
                                <Grid item>
                                    <TooltipAntd title="SINCRONIZAR CLIENTE CON EL MIKROTIK" color='purple' >
                                        <SwitchAntd 
                                            checked={Datos.AddClientMikrotik}
                                            checkedChildren="SI" 
                                            onChange={handleSwitchAdd}
                                            unCheckedChildren="NO" 
                                        />
                                    </TooltipAntd> 
                                </Grid>
                                <Grid item>
                                    <Alert severity='info'>                          
                                        SYNC CLIENT MK?
                                    </Alert>
                                </Grid>
                            </Grid>            
                        </Grid>
                        <Grid item lg={2} md={3} sm={4} xs={12}>
                            <Grid container  alignItems="center" spacing={1} style={{width:'100%'}} justifyContent='center'>
                                <Grid item>
                                    <TooltipAntd title="SINCRONIZAR PAGOS CON EL MIKROTIK" color='purple' >
                                        <SwitchAntd 
                                            checked={Datos.PagosConexion}
                                            checkedChildren="SI" 
                                            onChange={handleSwitchPago}
                                            unCheckedChildren="NO" 
                                        />
                                    </TooltipAntd> 
                                </Grid>
                                <Grid item>
                                    <Alert severity='info'>                          
                                        PAGOS MK?
                                    </Alert>
                                </Grid>
                            </Grid>            
                        </Grid>
                        <Grid item lg={2} md={2} sm={3} xs={4} style={{display:'grid', placeContent:'center'}}>
                            <TooltipAntd title="ZONA CON IPTV" color='purple' >
                                <SwitchAntd 
                                    checked={Datos.isIptv}
                                    checkedChildren="SI IPTV" 
                                    onChange={(checked)=>{setDatos({...Datos, isIptv:checked})}}
                                    unCheckedChildren="NO IPTV" 
                                />
                            </TooltipAntd>           
                        </Grid>
                        <Grid item lg={2} md={4} sm={5} xs={8}>
                            <Grid container  alignItems="center" spacing={1} style={{width:'100%'}} justifyContent='center'>
                                <Grid item>
                                    <TooltipAntd title="TIPO DE PLANES" color='purple' >
                                        <SwitchAntd 
                                            checked={Datos.planLocal}
                                            checkedChildren="ZONA" 
                                            onChange={handleSwitchPlanes}
                                            unCheckedChildren="GENERAL" 
                                        />
                                    </TooltipAntd>    
                                </Grid>
                                <Grid>
                                    <Alert severity='info'>                          
                                            PLANES?
                                    </Alert>
                                </Grid>
                            </Grid>            
                        </Grid>                 
                        <Grid item xs={12}>                              
                            <Grid container spacing={2} justifyContent='center'>
                                <Grid item>
                                    <FormGroup row style={{display:'flex', justifyContent:'center'}}>
                                        <FormControlLabel
                                            style={{margin:10}}
                                            control={
                                            <Switch
                                                checked={Datos.sysintercom}
                                                onChange={handleSwitch}
                                                name="sysintercom"
                                                color="primary"
                                                //disabled={!isRouterBoard}
                                            />
                                            }
                                            label="Ques/Address_Lists"
                                        />
                                        <FormControlLabel
                                            style={{margin:10}}
                                            control={
                                            <Switch
                                                checked={Datos.simpleQueue}
                                                onChange={handleSwitch}
                                                name="simpleQueue"
                                                color="primary"
                                                //disabled={!isRouterBoard}
                                            />
                                            }
                                            label="Ques_Simple"
                                        />
                                        <FormControlLabel
                                            style={{margin:10}}
                                            control={
                                            <Switch
                                                checked={Datos.queueTree}
                                                onChange={handleSwitch}
                                                name="queueTree"
                                                color="primary"
                                                //disabled={!isRouterBoard}
                                            />
                                            }
                                            label="Ques_tree"
                                        />
                                        <FormControlLabel
                                            style={{margin:10}}
                                            control={
                                            <Switch
                                                checked={Datos.ppoeList}
                                                onChange={handleSwitch}
                                                name="ppoeList"
                                                color="primary"
                                                //disabled={!isRouterBoard}
                                            />
                                            }
                                            label="Server_PPPoE"
                                        />
                                    </FormGroup>
                                </Grid>
                                <Grid item>
                                    <Alert severity='info'>                          
                                        Tipo de Manejo de Clientes
                                    </Alert>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <Grid container justifyContent='center' spacing={1}>
                                <Grid item >
                                    <Chip label=' S U B N E T S ' color='secondary' style={{color:'#fff', fontWeight:'bolder'}} icon={<VpnLockIcon />}/>
                                </Grid>
                                { SubnetEl }
                            </Grid>
                        </Grid>
                        {   Datos.isIptv &&
                            <Grid item xs={12} lg={6}>
                            <Grid container justifyContent='center' spacing={1}>
                                <Grid item >
                                    <Chip label=' S U B N E T S - I P T V ' color='secondary' style={{color:'#fff', fontWeight:'bolder'}} icon={<VpnLockIcon />}/>
                                </Grid>
                                { SubnetElIptv }
                            </Grid>
                            </Grid>
                        }
                        {   Datos.isFibraOptica &&
                            <Grid item xs={12} lg={6}>
                                <Grid container justifyContent='center' spacing={1}>
                                    <Grid item>
                                        <Chip label=' OLT ' color='secondary' style={{color:'#fff', fontWeight:'bolder'}} icon={<ClusterOutlinedIcon />}/>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Paper style={{width:'100%', padding:10, minHeight:68}} square elevation={2}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={8}>
                                                    <TextField
                                                        value={Datos.OLTIP || ''}
                                                        name='OLTIP'
                                                        onChange={handleDatos}
                                                        label='IP'
                                                        fullWidth
                                                        size='small'
                                                        variant='outlined'                                
                                                    />
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <TextField
                                                        value={Datos.OLTPORT || ''}
                                                        name='OLTPORT'
                                                        type='Number'
                                                        onChange={handleDatos}
                                                        label='PORT TELNET'
                                                        fullWidth
                                                        size='small'
                                                        variant='outlined'                              
                                                    />
                                                </Grid>
                                                <Grid item sm={6} xs={12}>
                                                    <TextField
                                                        value={Datos.OLTUSER || ''}
                                                        name='OLTUSER'
                                                        onChange={handleDatos}
                                                        label='USUARIO'
                                                        fullWidth
                                                        size='small'
                                                        variant='outlined'                                
                                                    />
                                                </Grid>
                                                <Grid item sm={6} xs={12}>
                                                    <TextField
                                                        value={Datos.OLTPASS || ''}
                                                        name='OLTPASS'
                                                        onChange={handleDatos}
                                                        label='PASSWORD'
                                                        fullWidth
                                                        size='small'
                                                        variant='outlined'                                
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </Grid>
                        }       
                    </Grid>
                    <Divider style={{marginTop:10}}/>
                </DialogContent> 
                <DialogActions style={{display:'flex', justifyContent:'center'}}>
                    <Button size='large' color='primary' startIcon={<SaveIcon/>} variant='contained' onClick={handleEditEquipo} >
                        {isProcessing ? <FacebookCircularProgress size={12} style={{marginTop:5}}/> : 'Guardar'}
                    </Button>
                    <Button size='large' color='secondary' variant='contained' onClick={handleAlertCloseEditInformacion}>
                        Cancelar
                    </Button>
                </DialogActions>
            </Dialog>     
            <Dialog
                open={showLogs}
                onClose={handleAlertLogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth={'lg'}
            >
                <DialogTitle id="customized-dialog-title" onClose={handleAlertLogClose}>
                    Logs
                </DialogTitle>
                <DialogContent>
                    <Paper style={{width:'100%'}}>
                        <TableContainer style={{maxHeight: 440}}>
                            <Table stickyHeader aria-label="simple table" >
                                <TableHead>
                                <TableRow>
                                    <TableCell style={{width:180}}>FECHA</TableCell>
                                    <TableCell>ASUNTO</TableCell>
                                    <TableCell>MENSAJE</TableCell>
                                </TableRow>
                                </TableHead>
                                <TableBody>
                                {isLogs.map((row) => (
                                    <TableRow key={row._id}>
                                        <TableCell >{row.time}</TableCell>
                                        <TableCell >{row.topics}</TableCell>
                                        <TableCell >{row.message}</TableCell>
                                    </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </DialogContent> 
            </Dialog> 
            <Dialog
                open={openPlanes}
                onClose={handleClosePlanes}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth={'xl'}
            >
                <DialogTitle id="customized-dialog-title" onClose={handleClosePlanes}>
                    <Chip label=' PLANES ' color='secondary' style={{color:'#fff', fontWeight:'bolder'}} icon={<SpeedIcon />}/>
                </DialogTitle>
                <DialogContent>
                    <Paper style={{width:'100%'}}>
                        <Grid container justifyContent='center'>
                            { PlanesEl}
                        </Grid>
                    </Paper>
                </DialogContent> 
                <DialogActions style={{display:'flex', justifyContent:'center'}}>
                    <Button size='large' color='primary' startIcon={<SaveIcon/>} variant='contained' onClick={handleEditEquipo} >
                        {isProcessing ? <FacebookCircularProgress size={12} style={{marginTop:5}}/> : 'Guardar'}
                    </Button>
                    <Button size='large' color='secondary' variant='contained' onClick={handleClosePlanes}>
                        Cancelar
                    </Button>
                </DialogActions>
            </Dialog> 
            <Dialog
                open={openCopy}
                onClose={handleCloseCopy}
                fullScreen
            >
                <DialogTitle id="customized-dialog-title" onClose={handleCloseCopy}>
                    Zona Nueva
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={3}>
                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                        {isProcessing ? <LinearProgress color='secondary' /> : <div style={{height:4}}></div>}
                        </Grid>     
                        <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
                            <Autocomplete
                                id="Marca"
                                options={Marcas.map(value=>value.Marca)}
                                value={Datos.Marca || ''}                              
                                renderInput={(params) => <TextField {...params} label="Marca" variant="outlined" size='small' fullWidth />}
                                onChange={(e,value, reason)=>{
                                    if(reason ===  'clear'){
                                        handleClearMarca()
                                    }else{
                                        handleSelectMarca(value);
                                    }
                                }}  
                            />
                        </Grid>                
                        <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
                            <Autocomplete
                                id="Modelo"
                                options={Modelos.map(value=>value.Modelo)}
                                disabled={isDisableModelo}
                                value={Datos.Modelo || ''}                              
                                renderInput={(params) => <TextField {...params} label="Modelo" variant="outlined" size='small' fullWidth />}
                                onChange={(e,value, reason)=>{
                                    if(reason ===  'clear'){
                                        handleClearModelo()
                                    }else{
                                        handleSelectModelo(value);
                                    }
                                }}  
                            />
                        </Grid>   
                        <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
                            <TextField
                                value={Datos.Zona || ''}
                                name='Zona'
                                onChange={handleDatos}
                                label='Zona'
                                fullWidth
                                size='small'
                                variant='outlined' 
                                InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <AddLocationIcon color='primary'/>
                                      </InputAdornment>
                                    ),
                                }}                               
                            />
                        </Grid>
                        <Grid item xl={2} lg={2} md={4} sm={4} xs={8}>
                            <TextField
                                value={Datos.IP || ''}
                                name='IP'
                                onChange={handleDatos}
                                label='IP'
                                fullWidth
                                size='small'
                                variant='outlined'     
                                InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <HttpIcon color='primary'/>
                                      </InputAdornment>
                                    ),
                                }}                           
                            />
                        </Grid> 
                        <Grid item xl={1} lg={1} md={2} sm={2} xs={4}>
                            <TextField
                                value={Datos.Puerto || ''}
                                name='Puerto'
                                onChange={handleDatos}
                                label='Puerto'
                                fullWidth
                                size='small'
                                variant='outlined' 
                                type='Number'                            
                            />
                        </Grid>
                        <Grid item xl={2} lg={2} md={4} sm={4} xs={12}>
                            <TextField
                                value={Datos.Usuario || ''}
                                name='Usuario'
                                onChange={handleDatos}
                                label='Usuario'
                                fullWidth
                                size='small'
                                variant='outlined'  
                                InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <PersonIcon color='primary'/>
                                      </InputAdornment>
                                    ),
                                }}                              
                            />
                        </Grid>        
                        <Grid item xl={3} lg={3} md={5} sm={4} xs={12}>
                            <TextField
                                value={Datos.Password || ''}
                                name='Password'
                                onChange={handleDatos}
                                label='Password'
                                fullWidth
                                size='small'
                                variant='outlined' 
                                InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <VpnKeyIcon color='primary' />
                                      </InputAdornment>
                                    ),
                                }}                              
                            />
                        </Grid>      
                        <Grid item xl={3} lg={3} md={5} sm={4} xs={12}>
                            <TextField
                                value={Datos.Provincia || ''}
                                name='Provincia'
                                onChange={handleDatos}
                                label='Provincia'
                                fullWidth
                                size='small'
                                variant='outlined'                              
                            />
                        </Grid>
                        <Grid item xl={3} lg={3} md={5} sm={4} xs={12}>
                            <TextField
                                value={Datos.Canton || ''}
                                name='Canton'
                                onChange={handleDatos}
                                label='Canton'
                                fullWidth
                                size='small'
                                variant='outlined'                              
                            />
                        </Grid>
                        <Grid item xl={3} lg={3} md={5} sm={4} xs={12}>
                            <TextField
                                value={Datos.Parroquia || ''}
                                name='Parroquia'
                                onChange={handleDatos}
                                label='Parroquia'
                                fullWidth
                                size='small'
                                variant='outlined'                              
                            />
                        </Grid>
                        <Grid item xl={2} lg={2} md={5} sm={4} xs={12}>
                            <TextField
                                value={Datos.Ciudad || ''}
                                name='Ciudad'
                                onChange={handleDatos}
                                label='Ciudad'
                                fullWidth
                                size='small'
                                variant='outlined'                              
                            />
                        </Grid>
                        <Grid item xl={2} lg={2} md={3} sm={4} xs={12}>
                            <Grid container  alignItems="center" spacing={1} style={{width:'100%'}} justifyContent='center'>
                                <Grid item>RADIO</Grid>
                                <Grid item>
                                    <Switch checked={Datos.isFibraOptica} onChange={handleSwitchFibra} name="isFibraOptica" color='primary'/>
                                </Grid>
                                <Grid item>FIBRA</Grid>
                            </Grid>            
                        </Grid>     
                        <Grid item xl={5} lg={5} md={7} sm={7} xs={12}>
                            <Grid container  alignItems="center" spacing={1} style={{width:'100%'}} justifyContent='center'>
                                <Grid item>OFF</Grid>
                                <Grid item>
                                    <Switch checked={Datos.AddClientMikrotik} onChange={handleSwitchAdd} name="AddClientMikrotik" color='primary'/>
                                </Grid>
                                <Grid item>ON</Grid>
                                <Grid item>
                                    <Alert severity='info'>                          
                                            Desea Agregar un Cliente Nuevo al MIKROTIK?
                                    </Alert>
                                </Grid>
                            </Grid>            
                        </Grid>              
                        <Grid item xl={5} lg={5} md={5} sm={5} xs={10}>
                            <Grid container  alignItems="center" spacing={1} style={{width:'100%'}} justifyContent='center'>
                                <Grid item>Off</Grid>
                                <Grid item>
                                    <Switch checked={Datos.PagosConexion} onChange={handleSwitchPago} name="PagosConexion" color='primary'/>
                                </Grid>
                                <Grid item>On</Grid>
                                <Grid item>
                                    <Alert severity='info'>                          
                                        Enlazar Pagos con el Mikrotik?
                                    </Alert>
                                </Grid>
                            </Grid>            
                        </Grid>

                        <Grid item xl={5} lg={5} md={12} sm={12} xs={12}>
                            <Grid container  alignItems="center" spacing={1} style={{width:'100%'}} justifyContent='center'>
                                <Grid item>GENERAL</Grid>
                                <Grid item>
                                    <Switch checked={Datos.planLocal} onChange={handleSwitchPlanes} name="planLocal" color='primary'/>
                                </Grid>
                                <Grid item>LOCAL</Grid>
                                <Grid item>
                                    <Alert severity='info'>                          
                                            Planes a nivel General o a nivel de Zona?
                                    </Alert>
                                </Grid>
                            </Grid>            
                        </Grid>
                        
                        <Grid item xs={12}>                              
                            <Grid container spacing={2} justifyContent='center'>
                                <Grid item>
                                    <FormGroup row style={{display:'flex', justifyContent:'center'}}>
                                        <FormControlLabel
                                            style={{margin:10}}
                                            control={
                                            <Switch
                                                checked={Datos.sysintercom}
                                                onChange={handleSwitch}
                                                name="sysintercom"
                                                color="primary"
                                                //disabled={!isRouterBoard}
                                            />
                                            }
                                            label="Ques/Address_Lists"
                                        />
                                        <FormControlLabel
                                            style={{margin:10}}
                                            control={
                                            <Switch
                                                checked={Datos.simpleQueue}
                                                onChange={handleSwitch}
                                                name="simpleQueue"
                                                color="primary"
                                                //disabled={!isRouterBoard}
                                            />
                                            }
                                            label="Ques_Simple"
                                        />
                                        <FormControlLabel
                                            style={{margin:10}}
                                            control={
                                            <Switch
                                                checked={Datos.queueTree}
                                                onChange={handleSwitch}
                                                name="queueTree"
                                                color="primary"
                                                //disabled={!isRouterBoard}
                                            />
                                            }
                                            label="Ques_tree"
                                        />
                                        <FormControlLabel
                                            style={{margin:10}}
                                            control={
                                            <Switch
                                                checked={Datos.ppoeList}
                                                onChange={handleSwitch}
                                                name="ppoeList"
                                                color="primary"
                                                //disabled={!isRouterBoard}
                                            />
                                            }
                                            label="Server_PPPoE"
                                        />
                                    </FormGroup>
                                </Grid>
                                <Grid item>
                                    <Alert severity='info'>                          
                                        Tipo de Manejo de Clientes
                                    </Alert>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                            <Grid container spacing={2} justifyContent='center' style={{width:'100%'}}>
                                <Grid item xs={12} lg={5}>
                                    <Grid container justifyContent='center' spacing={1}>
                                        {   Datos.isFibraOptica &&
                                            <Fragment>
                                                <Grid item xs={6}>
                                                    <Chip label=' OLT ' color='secondary' style={{color:'#fff', fontWeight:'bolder'}} icon={<ClusterOutlinedIcon />}/>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={8}>
                                                            <TextField
                                                                value={Datos.OLTIP || ''}
                                                                name='OLTIP'
                                                                onChange={handleDatos}
                                                                label='IP'
                                                                fullWidth
                                                                size='small'
                                                                variant='outlined'                                
                                                            />
                                                        </Grid>
                                                        <Grid item xs={4}>
                                                            <TextField
                                                                value={Datos.OLTPORT || ''}
                                                                name='OLTPORT'
                                                                type='Number'
                                                                onChange={handleDatos}
                                                                label='PORT TELNET'
                                                                fullWidth
                                                                size='small'
                                                                variant='outlined'                              
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Fragment>
                                        }
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} lg={7}>
                                    <Grid container justifyContent='center' spacing={1}>
                                        <Grid item >
                                            <Chip label=' S U B N E T S ' color='secondary' style={{color:'#fff', fontWeight:'bolder'}} icon={<VpnLockIcon />}/>
                                        </Grid>
                                        { SubnetEl }
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                              
                                    
                    </Grid>
                    <Divider style={{marginTop:10}}/>
                </DialogContent> 
                <DialogActions style={{display:'flex', justifyContent:'center'}}>
                    <Button size='large' color='primary' startIcon={<SaveIcon/>} variant='contained' onClick={()=>{setOpenConfirm(true);}} >
                        Continuar
                    </Button>
                    <Button size='large' color='secondary' variant='contained' onClick={handleCloseCopy}>
                        Cancelar
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openConfirm}
                onClose={handleCloseConfirm}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="customized-dialog-title" onClose={handleCloseConfirm}>
                    Desea Crear esta Zona?
                </DialogTitle>
                
                <DialogActions style={{display:'flex', justifyContent:'center'}}>
                    <Button size='large' color='primary' startIcon={<SaveIcon/>} variant='contained' onClick={handleSaveCopy} >
                        {isProcessing ? <FacebookCircularProgress size={12} style={{marginTop:5}}/> : 'Guardar'}
                    </Button>
                    <Button size='large' color='secondary' variant='contained' onClick={handleCloseConfirm}>
                        Cancelar
                    </Button>
                </DialogActions>
            </Dialog>
            <ModalAntd 
                title="CAMBIO DE NOMBRE DE ZONA?" 
                visible={openChangeZone} 
                onCancel={()=>{setOpenChangeZone(false)}} 
                confirmLoading={isProcessing}
                onOk={handleChangeNameZone} 
                okText='CONTINUAR'
                cancelText='CANCELAR'
                destroyOnClose
                bodyStyle={{display:'flex', justifyContent:'center', minHeight:100}}
            >
                <Grid container justifyContent='center' alignItems='center' spacing={2}>
                    <Grid item  md={8} xs={12}>
                        <TextField
                            value={getNewZone || ''}
                            name='ZonaNew'
                            onChange={({target})=>{setNewZone(target.value)}}
                            label='Nueva Zona'
                            fullWidth
                            size='small'
                            variant='outlined' 
                                                        
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Alert severity="info">ESTA MODIFICACIÓN AFECTARÁ VARIOS MÓDULOS!</Alert>
                    </Grid>
                </Grid>
            </ModalAntd>
            <TrYounetStyled >
                <TdYounetStyled minWidth={columns[0].minWidth} width={columns[0].minWidth} >
                    <Grid container>
                        <Grid item>
                            <Tooltip title='STATUS' placement="top" arrow>
                                <IconButton aria-label="expand row" size="small"onClick={handleInformacionStatus}>
                                    <AccountCircleIcon color='primary'/>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title='INTERFACES' placement="top" arrow>
                                <IconButton aria-label="expand row" size="small"onClick={handleInformacion}>
                                    <BallotIcon color='primary'/>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title='LOGS' placement="top" arrow>
                                <IconButton aria-label="expand row" size="small"onClick={handleLogs}>
                                    <AssignmentLateIcon color='primary'/>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title='EDIT' placement="top" arrow>
                                <IconButton aria-label="expand row" size="small"onClick={handleClickEdit}>
                                    <EditIcon style={{color:'green'}}/>
                                </IconButton>
                            </Tooltip>
                            <Popconfirm
                                title="DESEA CAMBIAR DE NOMBRE A LA ZONA?"
                                onConfirm={()=>{setOpenChangeZone(true)}}
                                okText="SI"
                                cancelText="NO"
                            >
                                <Tooltip title='CAMBIAR NOMBRE ZONA' placement="top" arrow>
                                <IconButton size="small" >
                                    <EditIcon style={{color:'dodgerBlue'}}/>
                                </IconButton>
                                </Tooltip>
                            </Popconfirm>
                            <Tooltip title='PLANES' placement="top" arrow>
                                <IconButton aria-label="expand row" size="small"onClick={handleOpenPlanes}>
                                    <SpeedIcon color='primary'/>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title='ELIMINAR' placement="right" arrow>
                                <IconButton aria-label="expand row" size="small" onClick={handleAlert}>
                                    <DeleteIcon style={{color:'red'}}/>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title='DUPLICAR' placement="right" arrow>
                                <IconButton aria-label="expand row" size="small" onClick={handleOpenCopy}>
                                    <ContentCopyIcon style={{color:'dodgerblue', fontSize:18}}/>
                                </IconButton>
                            </Tooltip>
                        </Grid>
                        <Grid item>
                            {isInfoCharging && <FacebookCircularProgress size={20} style={{marginTop:5}}/>}
                        </Grid>
                    </Grid>
                </TdYounetStyled>
                <TdYounetStyled minWidth={columns[1].minWidth} width={columns[1].minWidth} >
                    {rowInfo.Zona}
                </TdYounetStyled>
                <TdYounetStyled minWidth={columns[2].minWidth} width={columns[2].minWidth} >
                    {rowInfo.IP}
                </TdYounetStyled>
                <TdYounetStyled minWidth={columns[3].minWidth} width={columns[3].minWidth} >
                    {rowInfo.Puerto}
                </TdYounetStyled>
                <TdYounetStyled minWidth={columns[4].minWidth} width={columns[4].minWidth} >
                    {rowInfo.Marca}
                </TdYounetStyled>
                <TdYounetStyled minWidth={columns[5].minWidth} width={columns[5].minWidth} >
                    {rowInfo.Modelo}
                </TdYounetStyled>
                <TdYounetStyled minWidth={columns[6].minWidth} width={columns[6].minWidth} >
                    {rowInfo.Usuario}
                </TdYounetStyled>
                <TdYounetStyled minWidth={columns[7].minWidth} width={columns[7].minWidth} >
                    <>
                        {showPass ? rowInfo.Password : '********************'}
                        <IconButton size='small' onClick={handlePass}>
                            {showPass ? <VisibilityOffIcon style={{position:'relative', left:3, top:-2}} color='secondary'/> : <VisibilityIcon color='secondary' style={{position:'relative', left:3, top:-3}}/>}
                        </IconButton>
                    </>
                </TdYounetStyled>
            </TrYounetStyled>
        </div>
    );
};

const ElementPlan = memo((props)=>{
    const { index, total, id, handleBorrarPlanes, handleCrearPlanes, arrPlanes, handlePlanes, valor } = props;
    const [ Datos, setDatos ] = useState({Plan:'', Bajada:'', Subida:'', Valor:'', id, PlanComercial:'', Prioridad:'', Garantia:'', QueueTypeUpload:'', QueueTypeDownload:''});
    let cantItem = index + 1;

    useEffect(()=>{
        const { Plan, Bajada, Subida, Valor, id, _id, PlanComercial, Garantia, Prioridad, QueueTypeUpload, QueueTypeDownload } = valor;
        setDatos({Plan, Bajada, Subida, Valor, id, _id, PlanComercial, Garantia, Prioridad, QueueTypeUpload, QueueTypeDownload})
    },[]); // eslint-disable-line react-hooks/exhaustive-deps
  
    const handleSubBorrarPlanes = ()=>{handleBorrarPlanes(id);};

    const handleDatos = (e)=>{ setDatos({...Datos, [e.target.name]:e.target.value});};
    
    const handleSubPlanes = ()=>{ handlePlanes(id, Datos); };

    const handleSubPlanesName = ({target})=>{
        const arrP = [...arrPlanes];
        const arrF = arrP.filter(el=>el.id !== Datos.id );
        const arrFil = arrF.filter(el=>el.Plan.toString() === target.value );
        if(arrFil.length === 0 ){
            const objeto = {...Datos};
            objeto.Plan = target.value;
            handlePlanes(id, objeto);
        }else{
            alert('YA EXISTE UN PLAN IGUAL')
        }
    };

    return(         
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
            <Paper elevation={2} style={{padding:10}}>
                <Grid container justifyContent='center' spacing={1}>
                    <Grid item lg={3} md={6} sm={6} xs={12}>
                        <TextField
                            value={Datos.Plan || ''}
                            id={ `Plan_${index}`}
                            name='Plan'
                            onChange={handleDatos}
                            label='Plan'
                            fullWidth
                            size='small'
                            variant='outlined'  
                            onBlur={handleSubPlanesName} 
                            InputProps={{
                                startAdornment: (
                                <InputAdornment position="start">
                                    <SpeedIcon color='primary'/>
                                </InputAdornment>
                                ),
                            }}                                 
                        />
                    </Grid>
                    <Grid item lg={2} md={6} sm={6} xs={12}>
                        <TextField
                            value={Datos.PlanComercial || ''}
                            id='PlanComercial'
                            name='PlanComercial'
                            onChange={handleDatos}
                            label='Plan Comercial'
                            fullWidth
                            size='small'
                            variant='outlined'  
                            onBlur={handleSubPlanes}     
                            InputProps={{
                                startAdornment: (
                                <InputAdornment position="start">
                                    <SpeedIcon color='primary'/>
                                </InputAdornment>
                                ),
                            }}                               
                        />
                    </Grid>
                    <Grid item lg={1} md={2} sm={4} xs={6}>
                        <TextField
                            value={Datos.Bajada || ''}
                            id={ `Bajada_${index}`}
                            onChange={handleDatos}
                            label='Bajada'
                            name='Bajada'
                            fullWidth
                            size='small'
                            variant='outlined'  
                            onBlur={handleSubPlanes}     
                            InputProps={{
                                startAdornment: (
                                <InputAdornment position="start">
                                    <ArrowDownwardIcon color='primary'/>
                                </InputAdornment>
                                ),
                            }}                             
                        />
                    </Grid>
                    <Grid item lg={1} md={2} sm={4} xs={6}>
                        <TextField
                            value={Datos.Subida || ''}
                            id={ `Subida_${index}`}
                            name='Subida'
                            onChange={handleDatos}
                            label='Subida'
                            fullWidth
                            size='small'
                            variant='outlined'  
                            onBlur={handleSubPlanes}   
                            
                            InputProps={{
                                startAdornment: (
                                <InputAdornment position="start">
                                    <ArrowUpwardIcon color='primary'/>
                                </InputAdornment>
                                ),
                            }}                                 
                        />
                    </Grid>
                    <Grid item lg={1} md={2} sm={4} xs={6}>
                        <TextField
                            value={Datos.Garantia || ''}
                            id={ `Garantia_${index}`}
                            name='Garantia'
                            onChange={handleDatos}
                            label='Garantia'
                            fullWidth
                            size='small'
                            variant='outlined'  
                            onBlur={handleSubPlanes}                                   
                        />
                    </Grid>
                    <Grid item lg={1} md={2} sm={4} xs={6}>
                        <TextField
                            value={Datos.Prioridad || ''}
                            id={ `Prioridad_${index}`}
                            name='Prioridad'
                            onChange={handleDatos}
                            label='Prioridad'
                            fullWidth
                            size='small'
                            variant='outlined'  
                            onBlur={handleSubPlanes}                                   
                        />                               
                    </Grid>
                    <Grid item lg={1} md={2} sm={4} xs={6}>
                        <TextField
                            value={Datos.Valor || ''}
                            id={ `Valor_${index}`}
                            name='Valor'
                            onChange={handleDatos}
                            label='Valor'
                            fullWidth
                            size='small'
                            variant='outlined'  
                            onBlur={handleSubPlanes}       
                            
                            InputProps={{
                                startAdornment: (
                                <InputAdornment position="start">
                                    <AttachMoneyIcon color='primary'/>
                                </InputAdornment>
                                ),
                            }}                             
                        />
                    </Grid>
                    <Grid item lg={1} md={2} sm={4} xs={6}>
                        <TextField
                            value={Datos.QueueTypeUpload || ''}
                            id={ `QueueTypeUpload_${index}`}
                            name='QueueTypeUpload'
                            onChange={handleDatos}
                            label='Q. Type Up'
                            fullWidth
                            size='small'
                            variant='outlined'  
                            onBlur={handleSubPlanes}                                  
                        />
                    </Grid>
                    <Grid item lg={1} md={2} sm={4} xs={6}>
                        <TextField
                            value={Datos.QueueTypeDownload || ''}
                            id={ `QueueTypeDownload_${index}`}
                            name='QueueTypeDownload'
                            onChange={handleDatos}
                            label='Q. Type Down'
                            fullWidth
                            size='small'
                            variant='outlined'  
                            onBlur={handleSubPlanes}                                 
                        />
                    </Grid>
                    <Grid item lg={1} md={1} sm={4} xs={6} style={{display:'flex', justifyContent:'center', flexWrap:'no-wrap', alignItems:'center', gap:5}}>
                        {
                            arrPlanes.length === 1  ?
                            <IconButton onClick={handleCrearPlanes} >
                                <AddCircleOutlineIcon color='primary'/>
                            </IconButton> :
                            <Fragment>
                                { cantItem === total && 
                                    <Fragment >
                                        <IconButton onClick={handleCrearPlanes} size='small'        >
                                            <AddCircleOutlineIcon color='primary'/>
                                        </IconButton>
                                        <IconButton onClick={handleSubBorrarPlanes} size='small'        >
                                            <DeleteIcon style={{color:'red'}}/>
                                        </IconButton>
                                    </Fragment>
                                }
                            </Fragment>
                        }
                    </Grid>
                </Grid>
            </Paper>
        </Grid>   
    );
    
});

const ElementSubnet = memo((props)=>{
    const { index, total, id, handleBorrarSubnet, handleCrearSubnet, arrSubnet, handleSubnet, valor } = props;
    const [ Datos, setDatos ] = useState({Red:'', Mascara:0, id});
    let cantItem = index + 1;
  
    useEffect(()=>{
        const { Red, Mascara, id, _id } = valor;
        setDatos({Red, Mascara, id, _id})
    },[]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleSubBorrarSubnet = ()=>{ handleBorrarSubnet(id); };

    const handleDatos = (e)=>{ setDatos({...Datos, [e.target.id]:e.target.value}); };
    
    const handleSubSubnetRed = ({target})=>{
        const arrS = [...arrSubnet];
        const arrF = arrS.filter(el=>el.id !== Datos.id );
        const arrFil = arrF.filter(el=>el.Red.toString() === target.value );
        if(arrFil.length === 0 ){
            const objeto = {...Datos};
            objeto.Red = target.value;
            handleSubnet(id, objeto);
        }else{
            alert('YA EXISTE UN SEGMENTO DE RED IGUAL')
        }
    };

    const handleSubSubnetMask = ({target})=>{
        const objeto = {...Datos};
        objeto.Mascara = target.value;
        handleSubnet(id, objeto);
    };

    
    if(arrSubnet.length === 1){
        return(
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} >  
                <Paper elevation={2} style={{padding:10}} square >
                    <Grid container justifyContent='center' spacing={1}>
                        <Grid item xl={8} lg={8} md={8} sm={8} xs={8}>
                            <TextField
                                value={Datos.Red || ''}
                                id='Red'
                                onChange={handleDatos}
                                label='Red'
                                fullWidth
                                size='small'
                                variant='outlined'  
                                onBlur={handleSubSubnetRed}
                                InputProps={{
                                    startAdornment: (
                                    <InputAdornment position="start">
                                        <NatureIcon color='primary'/>
                                    </InputAdornment>
                                    ),
                                }}                             
                            />
                        </Grid>  
                        <Grid item xl={3} lg={3} md={3} sm={3} xs={3}>
                            <TextField
                                value={Datos.Mascara || ''}
                                id='Mascara'
                                type='Number'
                                onChange={handleDatos}
                                label='Mascara'
                                fullWidth
                                size='small'
                                variant='outlined'   
                                onBlur={handleSubSubnetMask}                           
                            />
                        </Grid>                  
                        <Grid item xl={1} lg={1} md={1} sm={1} xs={1}>
                            <IconButton onClick={handleCrearSubnet} style={{position:'relative', top:-3, left:-12}}>
                                <AddCircleOutlineIcon color='primary'/>
                            </IconButton>
                        </Grid>
                    </Grid>         
                </Paper>
            </Grid>             
        );
    }else{
        return(         
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <Paper elevation={2} style={{padding:10}} square>
                    <Grid container justifyContent='center' spacing={1} >
                        <Grid item xl={7} lg={7} md={7} sm={7} xs={7}>
                            <TextField
                                value={Datos.Red || ''}
                                id='Red'
                                onChange={handleDatos}
                                label='Red'
                                fullWidth
                                size='small'
                                variant='outlined'  
                                onBlur={handleSubSubnetRed}
                                InputProps={{
                                    startAdornment: (
                                    <InputAdornment position="start">
                                        <NatureIcon color='primary'/>
                                    </InputAdornment>
                                    ),
                                }}                             
                            />
                        </Grid>  
                        <Grid item xl={3} lg={3} md={3} sm={3} xs={3}>
                            <TextField
                                value={Datos.Mascara || ''}
                                id='Mascara'
                                type='Number'
                                onChange={handleDatos}
                                label='Mascara'
                                fullWidth
                                size='small'
                                variant='outlined'  
                                onBlur={handleSubSubnetMask}                            
                            />
                        </Grid>
                        <Grid item xl={2} lg={2} md={2} sm={2} xs={2}>
                            { cantItem === total && 
                            <Fragment >
                                <IconButton onClick={handleCrearSubnet} size='small' style={{position:'relative', top:5}}      >
                                    <AddCircleOutlineIcon color='primary'/>
                                </IconButton>
                                <IconButton onClick={handleSubBorrarSubnet} size='small' style={{position:'relative', top:5}}      >
                                    <DeleteIcon style={{color:'red'}}/>
                                </IconButton>
                            </Fragment>
                            }
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>   
        );
    }
    
});

const ElementSubnetIptv = memo((props)=>{
    const { index, total, id, handleBorrarSubnetIptv, handleCrearSubnetIptv, arrSubnetIptv, handleSubnetIptv } = props;
    const [ Datos, setDatos ] = useState({Red:'', Mascara:0, id});
    let cantItem = index + 1;
  
    const handleSubBorrarSubnetIptv = ()=>{ handleBorrarSubnetIptv(id); };

    const handleDatos = (e)=>{ setDatos({...Datos, [e.target.id]:e.target.value}); };

    const handleSubSubnetRedIptv = ({target})=>{
        const arrS = [...arrSubnetIptv];
        const arrF = arrS.filter(el=>el.id !== Datos.id ); 
        const arrFil = arrF.filter(el=>el.Red.toString() === target.value );
        if(arrFil.length === 0 ){
            const objeto = {...Datos};
            objeto.Red = target.value;
            handleSubnetIptv(id, objeto);
        }else{
            alert('YA EXISTE UN SEGMENTO DE RED IGUAL')
        }
    };

    const handleSubSubnetMaskIptv = ({target})=>{
        const objeto = {...Datos};
        objeto.Mascara = target.value;
        handleSubnetIptv(id, objeto);
    };

    if(arrSubnetIptv.length === 1){
        return(
            <Grid item xs={12} >  
                <Paper elevation={2} style={{padding:10}} square >
                    <Grid container justifyContent='center' spacing={1}>
                        <Grid item xl={8} lg={8} md={8} sm={8} xs={8}>
                            <TextField
                                value={Datos.Red || ''}
                                id='Red'
                                onChange={handleDatos}
                                label='Red'
                                fullWidth
                                size='small'
                                variant='outlined'  
                                onBlur={handleSubSubnetRedIptv}
                                InputProps={{
                                    startAdornment: (
                                    <InputAdornment position="start">
                                        <NatureIcon color='primary'/>
                                    </InputAdornment>
                                    ),
                                }}                             
                            />
                        </Grid>  
                        <Grid item xl={3} lg={3} md={3} sm={3} xs={3}>
                            <TextField
                                value={Datos.Mascara || ''}
                                id='Mascara'
                                type='Number'
                                onChange={handleDatos}
                                label='Mascara'
                                fullWidth
                                size='small'
                                variant='outlined'   
                                onBlur={handleSubSubnetMaskIptv}                           
                            />
                        </Grid>                  
                        <Grid item xl={1} lg={1} md={1} sm={1} xs={1}>
                            <IconButton onClick={handleCrearSubnetIptv} style={{position:'relative', top:-3, left:-12}}>
                                <AddCircleOutlineIcon color='primary'/>
                            </IconButton>
                        </Grid>
                    </Grid>         
                </Paper>
            </Grid>             
        );
    }else{
        return(         
            <Grid item xs={12}>
                <Paper elevation={2} style={{padding:10}} square>
                    <Grid container justifyContent='center' spacing={1} >
                        <Grid item xl={7} lg={7} md={7} sm={7} xs={7}>
                            <TextField
                                value={Datos.Red || ''}
                                id='Red'
                                onChange={handleDatos}
                                label='Red'
                                fullWidth
                                size='small'
                                variant='outlined'  
                                onBlur={handleSubSubnetRedIptv}
                                InputProps={{
                                    startAdornment: (
                                    <InputAdornment position="start">
                                        <NatureIcon color='primary'/>
                                    </InputAdornment>
                                    ),
                                }}                             
                            />
                        </Grid>  
                        <Grid item xl={3} lg={3} md={3} sm={3} xs={3}>
                            <TextField
                                value={Datos.Mascara || ''}
                                id='Mascara'
                                type='Number'
                                onChange={handleDatos}
                                label='Mascara'
                                fullWidth
                                size='small'
                                variant='outlined'  
                                onBlur={handleSubSubnetMaskIptv}                            
                            />
                        </Grid>
                        <Grid item xl={2} lg={2} md={2} sm={2} xs={2}>
                            { cantItem === total && 
                            <Fragment >
                                <IconButton onClick={handleCrearSubnetIptv} size='small' style={{position:'relative', top:5}}      >
                                    <AddCircleOutlineIcon color='primary'/>
                                </IconButton>
                                <IconButton onClick={handleSubBorrarSubnetIptv} size='small' style={{position:'relative', top:5}}      >
                                    <DeleteIcon style={{color:'red'}}/>
                                </IconButton>
                            </Fragment>
                            }
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>   
        );
    }
    
});

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
};
  
function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
};
  
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
};

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSorthandler = (property) => (event) => {
      onRequestSort(event, property);
    };
  
    return (
      <TableHead >
        <TableRow style={{display:'flex'}}>
          {columns.map((headCell) => (
            <TheadYounet  
                headCells={columns} 
                key={headCell.id} 
                widthDefault={headCell.minWidth} 
                createSortHandler={createSorthandler} 
                order={order} 
                orderBy={orderBy} 
                headCell={headCell} 
                classes={classes} 
                align={headCell.align}
            />
          ))}
        </TableRow>
      </TableHead>
    );
};

function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });
    useEffect(() => {
      // Handler to call on window resize
      function handleResize() {
        // Set window width/height to state
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
      // Add event listener
      window.addEventListener("resize", handleResize);
      // Call handler right away so state gets updated with initial window size
      handleResize();
      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
}

const ListadoEquipo = memo(({data=[], handleDelete, handleUpdate, Marcas, ModelosList, handleProcess, Empresas})=>{
    const size = useWindowSize();
    const [ order, setOrder] = useState('asc');
    const [ orderBy, setOrderBy] = useState('Zona');
    const classes = styles();
    const [ page, setPage] = useState(0);
    const [ rowsPerPage, setRowsPerPage] = useState(8);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return(

        <div style={{ maxWidth: '100%', minWidth:'100%', marginTop:2, overflowX:'auto', position:'relative'}}>
            <TableContainer >
                <Table aria-label="sticky table" size='small' style={{height:size.height === undefined ? 500 : size.height - 220, position:'sticky', top:0}}>

                <EnhancedTableHead
                    classes={classes}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    rowCount={data.length}
                    />
                <TableBody>
                {stableSort(data, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => 
                    <RowRB 
                        key={`RB-${index}`} 
                        Empresas={Empresas}
                        rowInfo={row} 
                        handleDelete={handleDelete} 
                        handleProcess={handleProcess}
                        handleUpdate={handleUpdate} 
                        Marcas={Marcas} 
                        ModelosList={ModelosList}
                    /> 
                )}
                </TableBody>
                
                </Table>
            </TableContainer>   
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={data.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage='Filas'
            />
            
        </div>
 
    )

});

const ListadoEquipos= ({data, handleProcess, handleUpdate, handleDelete, Marcas, ModelosList, Empresas})=>{
    return (
        <SnackbarProvider maxSnack={3} hideIconVariant={false} dense anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}>
            <ListadoEquipo 
                data={data}
                Empresas={Empresas} 
                handleProcess={handleProcess} 
                handleUpdate={handleUpdate} 
                handleDelete={handleDelete}
                Marcas={Marcas} 
                ModelosList={ModelosList}
            />
        </SnackbarProvider>
    );
};


export default ListadoEquipos;